let scrollBarWidth = null;
let scrollBarHeight = null;
/**
 * @method：getScrollBarWidth
 * @createdBy：HuangJian
 * @date：2019/1/12
 * @params:
 * @description：获取滚动条宽度
 */
export function getScrollBarWidth() {
    if (Vue.prototype.$isServer) return 0;
    if (scrollBarWidth !== null) return scrollBarWidth;

    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.height = '100px';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    scrollBarWidth = widthNoScroll - widthWithScroll;

    return scrollBarWidth;
};
/**
 * @method：getScrollBarHeight
 * @createdBy：HuangJian
 * @date：2019/1/12
 * @params:
 * @description：获取滚动条高度
 */
export function getScrollBarHeight() {
    if (Vue.prototype.$isServer) return 0;
    if (scrollBarHeight !== null) return scrollBarHeight;

    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.height = '100px';
    outer.style.width = '100px';
    outer.style.position = 'absolute';
    outer.style.top = '-9999px';
    document.body.appendChild(outer);

    const heightNoScroll = outer.offsetHeight;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.height = '100%';
    outer.appendChild(inner);

    const heightWithScroll = inner.offsetHeight;
    outer.parentNode.removeChild(outer);
    scrollBarHeight = heightNoScroll - heightWithScroll;

    return scrollBarHeight;
};
